var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9117 22.6148C74.5583 15.5477 72.4382 9.89399 68.5512 6.36042C63.9576 2.12014 57.2438 0 48.0565 0H0V19.788H40.9894C46.6431 19.788 49.47 22.6148 49.47 28.2686V31.0954C49.47 36.7491 46.6431 39.576 40.9894 39.576H14.1343V59.364H43.8163C49.47 59.364 52.2968 62.1908 52.2968 67.8445V71.0247L63.2509 47.7032C62.5442 47.3498 61.4841 46.9965 60.7774 46.9965C62.1908 46.6431 63.2509 45.9364 64.311 45.2297L74.9117 22.6148Z",
    fill: "url(#paint0_linear_17_3408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_3408",
    x1: -36.4787,
    y1: 1.56282e-7,
    x2: -17.4957,
    y2: 83.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#FF3D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D6C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.ae4608b79329c132d133d496ecdd73ab.svg";
export { ForwardRef as ReactComponent };